import { HTTP } from '@/services/http'
import { Settings } from '@/settings'
import { UserService } from '@/services/user-service'

export function vehicleImageUrl(imagename) {
    
	if (!UserService.hasAuth()) {
		return ''
	}

	if (typeof imagename === 'string' && imagename.startsWith('http')) {
		return imagename
	}

	return HTTP._formatUrl(`${Settings.API_BASE_URL}/attachment?key=${imagename}`, UserService.getAuth())
}